import Moment from 'moment';

export const secondsToTime = (seconds) => {
  // console.log(seconds)
  let secondsNum = parseInt(seconds)
  // console.log(secondsNum)
  if (secondsNum >= 3600 * 24) return
  // return moment.duration({secondsNum}).humanize()
  let hours = Math.floor(secondsNum / 3600) ? Math.floor(secondsNum / 3600) : '00'
  let mins = Math.floor((secondsNum % 3600) / 60) >= 10 ? Math.floor((secondsNum % 3600) / 60) : '0' + Math.floor((secondsNum % 3600) / 60)
  return hours + ':' + mins
}

export const timeStringToMomentObject = (timeString) => {
  // console.log(timeString)
  return Moment(timeString, 'HH:mm')
}
// console.log(secondsToTime(75690))

export const timeToSeconds = (time) => {
  let [hour, min] = time.split(':')
  return eval(hour * 3600 + min * 60)
}

// console.log(timeToSeconds('00:30'))
export const secondsToLongTime = (seconds) => {
  let secondsNum = parseInt(seconds)
  return Moment.duration({seconds: secondsNum}).humanize()
}
// console.log(Moment('1555294846').format())
// console.log(secondsToLongTime(234323))
export default {
  timeToSeconds,
  secondsToTime,
  secondsToLongTime,
  timeStringToMomentObject
}